import { useEffect } from 'react'
import { DEFAULT_DOCUMENT_TITLE, formatPageTitle } from '../utils/pageTitle'

/**
 * Sets `document.title` for the current route. Resets to the site default on unmount.
 */
export function usePageTitle(pageTitle: string | null | undefined): void {
  useEffect(() => {
    document.title = pageTitle ? formatPageTitle(pageTitle) : DEFAULT_DOCUMENT_TITLE
    return () => {
      document.title = DEFAULT_DOCUMENT_TITLE
    }
  }, [pageTitle])
}
